/* STEFANO - logica form rivenditori */
(function () {
  if (window.__rsLoaded) return;
  window.__rsLoaded = true;

  var i18n = {
    it: {
      ok: 'Richiesta inviata. Ti contatteremo al più presto.',
      err: 'Si è verificato un errore. Riprova o scrivici a b2b@panthos.it.',
      req: 'Compila tutti i campi obbligatori.',
      ts: 'Completa la verifica di sicurezza.',
    },
    en: {
      ok: 'Request sent. We will get back to you shortly.',
      err: 'Something went wrong. Please try again or email b2b@panthos.it.',
      req: 'Please fill in all required fields.',
      ts: 'Please complete the security check.',
    },
  };

  function init(form) {
    if (form.dataset.rsInit) return;
    form.dataset.rsInit = '1';
    var t = i18n[form.dataset.lang] || i18n.it;
    var endpoint = form.dataset.endpoint;
    var sitekey = form.dataset.sitekey;
    var btn = form.querySelector('.rs-submit');
    var ok = form.querySelector('.rs-msg--ok');
    var err = form.querySelector('.rs-msg--err');
    var loadedAt = Date.now();
    var widgetId = null;
    var token = '';

    function renderTurnstile() {
      var box = form.querySelector('.rs-turnstile');
      if (!sitekey || !box) return;
      if (!window.turnstile && !document.getElementById('rs-turnstile-api')) {
        var api = document.createElement('script');
        api.id = 'rs-turnstile-api';
        api.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        api.async = true;
        document.head.appendChild(api);
      }
      if (!window.turnstile) return void setTimeout(renderTurnstile, 300);
      widgetId = window.turnstile.render(box, {
        sitekey: sitekey,
        callback: function (tk) { token = tk; },
        'expired-callback': function () { token = ''; },
      });
    }
    renderTurnstile();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ok.classList.remove('show');
      err.classList.remove('show');

      var valid = true;
      form.querySelectorAll('[required]').forEach(function (el) {
        var bad = el.type === 'checkbox' ? !el.checked : !el.value.trim();
        el.classList.toggle('rs-invalid', bad);
        if (bad) valid = false;
      });
      if (!valid) { err.textContent = t.req; err.classList.add('show'); return; }
      if (sitekey && !token) { err.textContent = t.ts; err.classList.add('show'); return; }
      if (!endpoint) { err.textContent = t.err; err.classList.add('show'); return; }

      var d = new FormData(form);
      var payload = {
        type: 'reseller',
        company: d.get('company'), name: d.get('name'), email: d.get('email'), phone: d.get('phone'),
        vat: d.get('vat'), city: d.get('city'), website: d.get('website'),
        business_type: d.get('business_type'), message: d.get('message'),
        lang: form.dataset.lang, page: location.href,
        timestamp: new Date().toISOString(),
        hp: d.get('hp_field'), elapsed: Date.now() - loadedAt, ts_token: token,
      };

      // Risposta immediata: lo script Google impiega alcuni secondi (foglio + 2 mail), non aspettiamo la risposta
      btn.disabled = true;
      ok.textContent = t.ok;
      ok.classList.add('show');
      form.reset();
      loadedAt = Date.now();
      var sentToken = token;
      token = '';
      if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
      payload.ts_token = sentToken;

      fetch(endpoint, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload) })
        .catch(function () {
          ok.classList.remove('show');
          err.textContent = t.err;
          err.classList.add('show');
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  function scan() { document.querySelectorAll('.rs-form').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
